import React from 'react';
import { Zap, FileCheck, Users, Bell, Lock, BarChart3 } from 'lucide-react';
import './Features.css';

const features = [
  {
    icon: Users,
    title: "Matching automatique",
    description: "L'algorithme identifie les meilleurs binômes mandant/mandataire selon la proximité géographique et les disponibilités."
  },
  {
    icon: FileCheck,
    title: "CERFA pré-rempli",
    description: "Génération automatique du formulaire CERFA 14952*03 avec toutes les informations requises, prêt à imprimer."
  },
  {
    icon: Bell,
    title: "Suivi et relances",
    description: "Emails automatiques de rappel avant le scrutin et suivi du statut de chaque procuration en temps réel."
  },
  {
    icon: Zap,
    title: "Widget intégrable",
    description: "Formulaire personnalisable aux couleurs de votre campagne, intégrable sur n'importe quel site web."
  },
  {
    icon: Lock,
    title: "RGPD compliant",
    description: "Protection des données personnelles avec consentement explicite et droit d'accès/suppression garanti."
  },
  {
    icon: BarChart3,
    title: "Tableau de bord",
    description: "Vision claire de toutes vos procurations : en attente, validées, statistiques par bureau de vote."
  }
];

function Features() {
  return (
    <section id="features" className="features">
      <div className="features__container container">
        <div className="features__header">
          <span className="features__label">Fonctionnalités</span>
          <h2 className="features__title">
            Tout ce dont vous avez besoin pour gérer vos procurations
          </h2>
          <p className="features__subtitle">
            ProcuMatcher automatise l'ensemble du processus, de l'inscription à la validation finale.
          </p>
        </div>
        
        <div className="features__grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-card__icon">
                <feature.icon size={28} />
              </div>
              <h3 className="feature-card__title">{feature.title}</h3>
              <p className="feature-card__description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;

